import styled from 'styled-components';

export const TooltipContainer = styled.div`
    position: fixed;
    z-index: 1000;
    padding: 1rem;
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border: 1px solid #e0e0e0;
    max-width: 600px; 
    font-family: Arial, sans-serif;
    transform: translate(0, 0); 
`;

export const TooltipContent = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr; 
    gap: 1.5rem; 
    margin-top: 0.5rem;
`;

export const Header = styled.h4`
    font-size: 1rem;
    font-weight: bold;
    color: #333;
    margin-bottom: 0.5rem;
`;

export const Column = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
`;

export const Label = styled.span`
    font-size: 0.8rem;
    font-weight: 600;
    color: #666;
`;

export const Value = styled.span`
    font-size: 0.9rem;
    color: #333;
    white-space: pre-wrap;
    word-wrap: break-word;
`;